
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: { organizationName: String },
})
export default class BannerPwa extends Vue {
  event: any;
  bannerInstall: any;

  mounted() {
    this.bannerInstall = document.getElementById("installBanner");

    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.event = e;
      if (this.bannerInstall !== null) {
        this.bannerInstall.style.display = "block";
        setTimeout(() => {
          this.disposeBannerPwa();
        }, 12000);
      }
    });

    window.addEventListener("appinstalled", (e) => {
      if (this.bannerInstall !== null) {
        this.bannerInstall.style.display = "none";
      }
      console.log(e);
    });
  }

  disposeBannerPwa() {
    this.$ga.event("Recusou PWA", "dispose-pwa", "Click dispose PWA");
    this.bannerInstall.style.display = "none";
  }

  async clickInstallApp() {
    this.event.prompt();

    let result = await this.event.userChoice;
    this.bannerInstall.style.display = "none";
    this.event = null;
    if (result.outcome === "dismissed") {
      this.$ga.event("Recusou PWA", "dispose-pwa", "Click dispose PWA");
    } else {
      this.$ga.event("Instalou PWA", "install-pwa", "Click instalar PWA");
    }
  }
}
